<template>
    <div id="app-ticket">
        <v-app :lang="$i18n.locale">
            <div class="d-flex">
                <v-card
                    color="#F4F4F9"
                    elevation="0"
                    width="32"
                    height="290"
                    class="my-2"
                    style="border-radius: 10px 0px 0px 10px; border: 0.1em solid #D4D9DE ; border-right-style: none;"
                >
                    <v-card-text class="pa-0">
                        <div class="d-flex align-end" id="margin-logo">
                            <v-img
                                :src="require('@/assets/logo_small.svg')"
                                eager
                                contain
                                width="21.6"
                                height="18.8"
                            />
                        </div>
                    </v-card-text>
                </v-card>
                <v-card
                    color="#FFFFFF"
                    elevation="0"
                    width="652"
                    height="290"
                    class="my-2 pb-0"
                    style="border-radius: 0 10px 10px 0; border: 0.1em solid #D4D9DE ; border-left-style: none;"
                >
                    <v-card-text>
                        <v-row>
                            <v-col cols="6" md="6" sm="6">
                                <v-row>
                                    <v-col cols="12" md="12" sm="12">
                                        <div
                                            class="pa-0 prompt- mt-0"
                                            style="
                                                color: #37323c;
                                                font-size: 17px;
                                                font-weight: 500;
                                            "
                                        >
                                            {{$t('message.applicationIDcard.applicationIDcard')}}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="4"
                                        md="4"
                                        sm="4"
                                        class="pb-0 pt-0"
                                    >
                                        <v-img
                                            class="logo"
                                            :src="
                                                organizationDetail
                                                    ?.school_logo_base64?.data
                                            "
                                            alt="logo"
                                            eager
                                            contain
                                            width="82"
                                        />
                                    </v-col>
                                    <v-col
                                        cols="8"
                                        md="8"
                                        sm="8"
                                        class="pb-0 pl-1 pt-0"
                                    >
                                        <div
                                            class="pa-0 mb-0 ticket__text"
                                        >
                                            {{ organizationDetail?.[`name_${this.locale}`] }}
                                        </div>
                                        <div
                                            class="pa-0 mb-0 ticket__text"
                                        >
                                            {{$t('message.applicationIDcard.academicYear')}} {{registrationFormDetail?.semester_year}}
                                        </div>
                                        <div
                                            class="pa-0 mb-0 ticket__text"
                                            v-if="student?.register_plan"
                                        >
                                            {{
                                                student?.register_plan
                                                    ?.student_year
                                                    ?.[`student_year_name_${this.locale}`]
                                            }}
                                        </div>
                                        <div
                                            class="pa-0 mb-3 ticket__text"
                                            v-if="student?.register_plan"
                                        >
                                            {{$t('message.applicationIDcard.curriculum')}}
                                            {{
                                                student?.register_plan?.program
                                                    ?.[`program_name_${this.locale}`]
                                            }}
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-divider
                                        class="ma-0 pa-0 mb-3"
                                        style="border:0.125em solid #f4f4f9;"
                                    ></v-divider>
                                </v-row>
                                <v-row class="mt-0">
                                    <v-col
                                        cols="6"
                                        md="6"
                                        sm="6"
                                        class="pt-1 pb-1"
                                    >
                                        <div
                                            class="pa-0 prompt-caption"
                                            style="
                                                color: #37323c;
                                                font-size: 11px;
                                            "
                                        >
                                            {{$t('message.applicationIDcard.examDate')}}
                                        </div>
                                        <div
                                            class="pa-0 mt-n1 ticket__text"
                                        >
                                            {{ examDate }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="6"
                                        md="6"
                                        sm="6"
                                        class="pt-1 pb-1"
                                    >
                                        <div
                                            class="pa-0 prompt-caption"
                                            style="
                                                color: #37323c;
                                                font-size: 11px;
                                            "
                                        >
                                            {{$t('message.applicationIDcard.no')}}
                                        </div>
                                        <div
                                            class="pa-0 mt-n1 ticket__text"
                                        >
                                            {{ student?.seat_number || "-" }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        sm="12"
                                        class="pt-1 pb-0"
                                    >
                                        <div
                                            class="pa-0 prompt-caption"
                                            style="
                                                color: #37323c;
                                                font-size: 11px;
                                            "
                                        >
                                            {{$t('message.applicationIDcard.testVenue')}}
                                        </div>
                                        <div
                                            class="pa-0 mt-n1 ticket__text"
                                        >
                                            {{
                                                registrationFormDetail?.exam_location
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        md="12"
                                        sm="12"
                                        class="pt-2"
                                    >
                                        <div
                                            class="pa-0 mt-0 mb-2 ticket__text"
                                        >
                                            {{$t('message.applicationIDcard.export')}} {{ todayDate }}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="1" md="1" sm="1" class="ml-n3 mt-n4">
                            <v-divider
                                vertical
                                style="border:0.125em solid #f4f4f9;"
                            ></v-divider>
                            </v-col>
                            <v-col cols="5" md="5" sm="5" >
                                <v-row>
                                    <v-col
                                        cols="8"
                                        md="8"
                                        sm="8"
                                        class="ml-n6 mr-n6"
                                    >
                                        <div
                                            class="pa-0 prompt-caption mt-0"
                                            style="
                                                color: #37323c;
                                                font-size: 11px;
                                            "
                                        >
                                            {{$t('message.applicationIDcard.idCard')}}
                                        </div>
                                        <div
                                            class="pa-0 mt-n1 mb-2 ticket__text"
                                            v-if="student?.student_detail"
                                        >
                                            {{
                                                student?.student_detail
                                                    ?.national_id
                                            }}
                                        </div>

                                        <div
                                            class="pa-0 prompt-caption"
                                            style="
                                                color: #37323c;
                                                font-size: 11px;
                                            "
                                        >
                                            {{$t('message.applicationIDcard.fullName')}}
                                        </div>
                                        <div
                                            class="pa-0 mt-n1 mb-2 ticket__text"
                                            v-if="student?.student_detail"
                                        >
                                            {{
                                                student?.student_detail
                                                    ?.prefix_id?.[`text_${this.locale}`]
                                            }}
                                            {{
                                               student?.student_detail?.[`name_${this.locale}`]
                                            }}
                                            <br v-if="studentNameLengthLimit"/>
                                            {{
                                                student?.student_detail
                                                    ?.[`surname_${this.locale}`]
                                            }}
                                        </div>

                                        <div
                                            class="pa-0 prompt-caption"
                                            style="
                                                color: #37323c;
                                                font-size: 11px;
                                            "
                                        >
                                            {{$t('message.applicationIDcard.formerSchool')}}
                                        </div>
                                        <div
                                            class="pa-0 mt-n1 mb-0 ticket__text"
                                            v-if="student?.student_other_detail"
                                        >
                                            {{
                                                student?.student_other_detail
                                                    ?.former_school_name
                                            }}
                                        </div>
                                        <div
                                            class="pa-0 mt-0 ticket__text"
                                            v-if="student?.student_other_detail"
                                        >
                                            {{$t('message.applicationIDcard.province')}}
                                            {{
                                                student?.student_other_detail
                                                    ?.former_school_province
                                                    ?.[`name_${this.locale}`]
                                            }}
                                        </div>
                                    </v-col>
                                    <v-col
                                        cols="4"
                                        md="4"
                                        sm="4"
                                        class="mt-1 px-0"
                                        style="position: absolute; margin-left: 9rem;"
                                    >
                                        <v-img
                                            v-if="
                                                student?.student_detail
                                                    ?.student_img_base64 != null
                                            "
                                            :src="
                                                student?.student_detail
                                                    ?.student_img_base64?.data
                                            "
                                            :width=120
                                            eager
                                            contain
                                        />
                                        <v-img
                                            v-else
                                            :src="
                                                require('@/assets/image 20.svg')
                                            "
                                            :width=120
                                            eager
                                            contain
                                        />
                                    </v-col>
                                </v-row>
                                <v-row style="position:absolute;margin-top: 2rem; width:300px">
                                    <v-col cols="12" md="12" sm="12" class="ml-n6">
                                        <v-divider
                                            class="ma-0 pa-0"
                                        ></v-divider>
                                        <div
                                            class="
                                                pa-0
                                                mt-1
                                                d-flex
                                                justify-center
                                                ticket__text
                                            "
                                        >
                                            {{$t('message.applicationIDcard.signature')}}
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </div>
        </v-app>
    </div>
</template>

<script>
import { formatDateTime } from "@/utils/date";
import i18n from '@/i18n';
export default {
    name: "TicketPart",
    props: {
        student: Object,
        organizationDetail: Object,
        registrationFormDetail: Object,
    },
    computed: {
        locale(){
            return i18n.locale;
        },
        examDate() {
            let newDate = Date.parse(this.registrationFormDetail.exam_date);
            if (newDate) return formatDateTime(newDate, this.locale);
            else return "";
        },
        todayDate() {
            let newDate = new Date();
            if (newDate) return formatDateTime(newDate, this.locale);
            else return "";
        },
        studentNameLengthLimit(){
            let name = this.student?.student_detail?.prefix_id?.[`text_${this.locale}`]
            name = `${name} ${this.student?.student_detail?.[`name_${this.locale}`]}`
            name = `${name} ${this.student?.student_detail?.[`surname_${this.locale}`]}`
            if(name.length >= 25){
                return true
            }
            return false
        },
    },
};
</script>

<style scoped lang="scss">
#app-ticket {
    margin-top: 100px;
    margin-left: 50px;
    width: 1139px;
    height: 500px;
}

#margin-logo {
    margin-top: 16rem;
}

.ticket__text{
    color: #37323c;
    font-family: 'Sarabun';
    font-size: 14px;
    .v-application[lang="en"] & {
        font-family: "inter", sans-serif !important;
    }
}
</style>
